/**
 * @generated SignedSource<<768a68af8bbf1a4e59a827dd3bfdb871>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type healthAndHappinessQuery$data = {
  readonly healthAndHappinessQueue: {
    readonly items: {
      readonly __typename: "QueueItemConnection";
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly " $fragmentSpreads": FragmentRefs<"healthAndHappinessItemQuery">;
        };
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly healthAndHappinessSection: {
    readonly " $fragmentSpreads": FragmentRefs<"headlineSection">;
  };
  readonly " $fragmentType": "healthAndHappinessQuery";
};
export type healthAndHappinessQuery$key = {
  readonly " $data"?: healthAndHappinessQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"healthAndHappinessQuery">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "healthAndHappinessQuery",
  "selections": [
    {
      "alias": "healthAndHappinessSection",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "entityId": "515935"
          }
        }
      ],
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "section",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "headlineSection"
        }
      ],
      "storageKey": "section(filter:{\"entityId\":\"515935\"})"
    },
    {
      "alias": "healthAndHappinessQueue",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "name": "section_top_515935"
          }
        }
      ],
      "concreteType": "Queue",
      "kind": "LinkedField",
      "name": "queue",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 3
            }
          ],
          "concreteType": "QueueItemConnection",
          "kind": "LinkedField",
          "name": "items",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "QueueItemsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "healthAndHappinessItemQuery"
                        }
                      ],
                      "type": "Article",
                      "abstractKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "items(first:3)"
        }
      ],
      "storageKey": "queue(filter:{\"name\":\"section_top_515935\"})"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "4daaafd2409db835f2082c85fff96bdf";

export default node;
